export const formattedAmount = (value: any) => {
  const formatted = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
    currencyDisplay: 'symbol', // default shows ₹
  }).format(value || 0);

  // Replace ₹ symbol with "Rs"
  return formatted.replace('₹', 'Rs.');
}

